import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap'; 
import { fetchRoleDetailsPublicByIdApi } from '../services/api'; 

import MetaTags from '../components/MetaTags';

// Reused/New Components
import AuditionDetailHeader from '../components/audition-detail/AuditionDetailHeader';
import AuditionBookingWizard from '../components/audition-detail/AuditionBookingWizard';

// Utilities
import { transformAuditionData } from '../utils/auditionDetailHelpers'; 
import { compileSchema } from 'ajv/dist/compile';
import CastingDirectorCard from '../components/audition-booking-wizard/CastingDirectorCard';

const AuditionDetailPage = () => {
  const { id, urlSlug } = useParams(); 
  const [audition, setAudition] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const getDetails = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      
      const response = await fetchRoleDetailsPublicByIdApi(id, urlSlug);
      const rawResponseData = response.data?.data || response.data;
      const raw = (Array.isArray(rawResponseData) && rawResponseData.length > 0) ? rawResponseData[0] : null;
      // console.log("raw----",raw);
      if (raw) {
        const transformedAudition = transformAuditionData(raw, id);
        setAudition(transformedAudition);
      } else {
        setError('Audition details not found.');
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      setError('Server Connection Error or invalid role ID/slug.');
    } finally {
      setLoading(false);
    }
  }, [id, urlSlug]);

  useEffect(() => {
    if (id) getDetails();
  }, [id, getDetails]);

  if (loading) return (
    <div style={{background: '#1a1a1a', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <Spinner animation="border" variant="danger" />
        <h5 className="text-white ms-3 mt-3">Fetching Details...</h5>
    </div>
  );

  if (error || !audition) return (
    <div className="text-center p-5" style={{background:'#1a1a1a', minHeight:'100vh', color:'white'}}>
      <h3 className="text-danger">{error || 'Role Not Found'}</h3>
      <Link to="/roles" className="btn btn-outline-light mt-3">Back to Browse</Link>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', color: 'white', backgroundColor: '#1a1a1a' }}> 
      <MetaTags title={`${audition.projectName} - ${audition.roleName}`} />
      
      <main className="audition-detail-main-container"> 
        <AuditionDetailHeader audition={audition} />

        <section id="audition_booking_section" className="py-4 py-md-5">
          <Container fluid className="px-3 px-md-5"> 
            {/* <Row className="justify-content-center">
              <Col lg={10} md={12}>
                 <div style={{ width: "100%", maxWidth:"1100px", margin: "0 auto" }}>
                    <AuditionBookingWizard audition={audition} />
                 </div>
              </Col>   
            </Row> */}
            <Row className="g-4 align-items-start">

              {/* LEFT SIDE */}
              <Col lg={8} md={12}>
                <AuditionBookingWizard audition={audition} />
              </Col>

              {/* RIGHT SIDE */}
              <Col lg={4} md={12}>
  <CastingDirectorCard audition={audition} />
</Col>

            </Row>
          </Container>
        </section>
      </main>
    </div>
  );
};

export default AuditionDetailPage;